import type { NormalizeOAS, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/DowngradeSubscriptionPlan', 'post'>;

type Params = {
  lookupKey: string;
};

export const downgradeSubscriptionFactory = (apiClient: ApiClient) => {
  const downgradeSubscription = async (variables: Params): Promise<void> => {
    const requestParams = mapInputToRequestParams(variables);
    await apiClient['/api/DowngradeSubscriptionPlan'].post(requestParams);
  };

  const mapInputToRequestParams = (input: Params): RequestParams => {
    return {
      json: {
        lookupKey: input.lookupKey,
      },
    };
  };

  return downgradeSubscription;
};
